import { create } from "zustand";
import { subscriptions as seed } from "@/mocks/seed";
import type { Subscription } from "@/types";

/** Mock store for subscriptions when unauthenticated / API down (Phase 5.3). */
interface SubscriptionsState {
  active: Subscription[];
  archived: Subscription[];
  add: (sub: Subscription) => void;
  update: (id: string, patch: Partial<Subscription>) => void;
  archive: (id: string) => void;
  restore: (id: string) => void;
}

export const useSubscriptionsStore = create<SubscriptionsState>((set) => ({
  active: seed,
  archived: [],
  add: (sub) => set((s) => ({ active: [...s.active, sub] })),
  update: (id, patch) =>
    set((s) => ({ active: s.active.map((x) => (x.id === id ? { ...x, ...patch } : x)) })),
  archive: (id) =>
    set((s) => {
      const target = s.active.find((x) => x.id === id);
      if (!target) return s;
      return { active: s.active.filter((x) => x.id !== id), archived: [target, ...s.archived] };
    }),
  restore: (id) =>
    set((s) => {
      const target = s.archived.find((x) => x.id === id);
      if (!target) return s;
      return { archived: s.archived.filter((x) => x.id !== id), active: [...s.active, target] };
    }),
}));
